var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "area-selection" }, [
    _c(
      "div",
      { staticClass: "area-selection__form" },
      [
        _c(
          "q-card-section",
          { staticClass: "area-selection__header flex q-gutter-md" },
          [_vm._t("header")],
          2
        ),
        _vm._v(" "),
        _c("q-card-section", { staticClass: "area-selection__content" }, [
          _c("div", { staticClass: "area-selection__content-left" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("q-input", {
                  staticClass: "form-group__control",
                  attrs: {
                    outlined: "",
                    rules: [_vm.requiredRule],
                    "lazy-rules": "ondemand",
                    label: "Имя"
                  },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.area.name,
                    callback: function($$v) {
                      _vm.$set(_vm.area, "name", $$v)
                    },
                    expression: "area.name"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("q-input", {
                  staticClass: "form-group__control",
                  attrs: {
                    outlined: "",
                    "lazy-rules": "ondemand",
                    label: "Описание"
                  },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.area.description,
                    callback: function($$v) {
                      _vm.$set(_vm.area, "description", $$v)
                    },
                    expression: "area.description"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group q-gutter-md" }, [
              _c(
                "div",
                { staticClass: "form-group__control text-right" },
                [
                  !_vm.maxShapes || _vm.shapes.length < _vm.maxShapes
                    ? _c("q-btn", {
                        attrs: {
                          color: "primary",
                          icon: "add",
                          label: "Добавить фигуру"
                        },
                        on: { click: _vm.addMainShape }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "figures-list" }, [
              _c(
                "div",
                { staticClass: "figures-list__scroll-area" },
                _vm._l(_vm.shapes, function(shape, shapeIndex) {
                  return _c(
                    "div",
                    { key: shapeIndex, staticClass: "polygon" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group form-group--horizontal q-gutter-md justify-between"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "form-group__label text-h5" },
                            [
                              _vm._v(
                                "\n                  Фигура\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-group__control polygon__controls"
                            },
                            [
                              !shape.polygon.editor.state.get("drawing")
                                ? _c("q-btn", {
                                    attrs: { color: "primary", icon: "edit" },
                                    on: {
                                      click: function($event) {
                                        return _vm.startDrawing(shape.polygon)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              shape.polygon.editor.state.get("drawing")
                                ? _c("q-btn", {
                                    attrs: { color: "primary", icon: "done" },
                                    on: {
                                      click: function($event) {
                                        return _vm.stopDrawing(shape.polygon)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.shapes.length > 1
                                ? _c("q-btn", {
                                    attrs: { color: "primary", icon: "delete" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeShape(shape)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("q-separator", { staticClass: "q-mb-lg" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group q-gutter-md" }, [
                        _c(
                          "div",
                          { staticClass: "form-group__control text-right" },
                          [
                            shape.contours.length < _vm.maxContours
                              ? _c("q-btn", {
                                  attrs: {
                                    color: "primary",
                                    icon: "add",
                                    label: "Добавить контур"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addContour(shape.polygon)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(shape.contours, function(contour, contourIndex) {
                        return _c(
                          "div",
                          {
                            key: contourIndex,
                            staticClass: "figure form-group",
                            on: {
                              click: function($event) {
                                return _vm.selectContour(
                                  shape.polygon,
                                  contourIndex
                                )
                              }
                            }
                          },
                          [
                            _c("q-field", {
                              staticClass: "form-group__control",
                              class: [
                                {
                                  "q-field--focused":
                                    contourIndex ===
                                      shape.polygon.editor.state.get(
                                        "drawingPath"
                                      ) &&
                                    shape.polygon.editor.state.get("drawing")
                                }
                              ],
                              attrs: {
                                value: contour.getLength(),
                                outlined: "",
                                label: "Контур",
                                rules: [_vm.requiredRule, _vm.numberRangeRule],
                                "lazy-rules": "ondemand"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "control",
                                    fn: function() {
                                      return [
                                        _vm._v(
                                          "\n                    Точек: " +
                                            _vm._s(contour.getLength()) +
                                            "\n                  "
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "append",
                                    fn: function() {
                                      return [
                                        shape.contours.length > 1
                                          ? _c("q-btn", {
                                              attrs: { label: "X" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.removeContour(
                                                    shape.polygon,
                                                    contourIndex
                                                  )
                                                }
                                              }
                                            })
                                          : _c("q-btn", {
                                              attrs: { icon: "close" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.clearContour(
                                                    contour
                                                  )
                                                }
                                              }
                                            })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "area-selection__content-right" }, [
            _c("div", {
              ref: "map",
              staticClass: "area-selection__map full-height full-width"
            })
          ])
        ]),
        _vm._v(" "),
        _c(
          "q-card-section",
          { staticClass: "area-selection__footer" },
          [_vm._t("footer")],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }